export default "__VITE_ASSET__C8Z5AGbR__"